<template>
  <div class="kxjscxjg">
    <Header :title="title" type='0' route='/kx_bindex'></Header>
    <div class="table">
      <el-table style="width: 100%;" :data="tableData">
        <el-table-column label="教室名称/类型/座位数" align="center" width="240">
          <el-table-column prop="jsmc" label="名称" align="center" width="120" />
          <el-table-column prop="jslxmc" label="类型" align="center" />
          <el-table-column prop="zws" label="座位数" align="center" />
        </el-table-column>
        <el-table-column label="节次" align="center">
          <el-table-column v-for="(i,c) in jcArr" :key="c" :prop="i.prop" align="center">
            <template #header>
              <p v-for="(q,w) in i.arr" :key="w">{{ q }}</p>
            </template>
            <template slot-scope="scope">
              <div style="margin:0 auto;" v-if="scope.row[i.prop]" :class="['round',
                scope.row[i.prop] === '1'?'ys-hei':'',
                scope.row[i.prop] === '2'?'ys-lv':'',
                scope.row[i.prop] === '3'?'ys-chen':'',
                scope.row[i.prop] === '4'?'ys-hong':'',
                scope.row[i.prop] === '6'?'ys-lan':'',
                scope.row[i.prop] === '7'?'ys-ban':'',
                scope.row[i.prop] === '9'?'ys-zi':'',
                scope.row[i.prop] === '10'?'ys-huang':'',
              ]" />
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="ys-all">
      <div class="ys-li" v-for="(i,index) in jssyzt" :key="index">
        <div :class="['round',
          i.dm === '1'?'ys-hei':'',
          i.dm === '2'?'ys-lv':'',
          i.dm === '3'?'ys-chen':'',
          i.dm === '4'?'ys-hong':'',
          i.dm === '6'?'ys-lan':'',
          i.dm === '7'?'ys-ban':'',
          i.dm === '9'?'ys-zi':'',
          i.dm === '10'?'ys-huang':'',
         ]"/>
        {{i.dmmc}}
      </div>
    </div>
  </div>
</template>
<script>
import { Api } from "../../../../utils/axios";
export default{
  data(){
    return{
      title:'',
      jssyzt:[],
      weekList:[
        { text:"周一", value:'1' },
        { text:"周二", value:'2' },
        { text:"周三", value:'3' },
        { text:"周四", value:'4' },
        { text:"周五", value:'5' },
        { text:"周六", value:'6' },
        { text:"周日", value:'7' },
      ],
      jcArr:[],
      tableData:[]
    }
  },
  created(){
    this.weekList.forEach(i=>{
      if(this.$route.params.obj.week === i.value){
        this.title = this.$route.params.obj.zctext + ' ' + i.text + ' ' + '查询结果'
      }
    })
    this.bigJcFuct()
    this.getData()
  },
  methods:{
    async bigJcFuct(){
      const res = await Api.bigJcNode();
      var concatList = []
      this.jcArr = []
      res.data.forEach((item, index) => {
        var one = item.JC.slice(0,2)
        var two = item.JC.slice(2,4)
        if(item.JC === '091011'){
          var three = item.JC.slice(4,6)
          concatList[index] = {
            arr:[one,two,three],
            value: one+','+two+','+three,
            nodeName: item.JC,
            prop:one,
          };
        }else{
          concatList[index] = {
            arr:[one,two],
            value: one+','+two,
            nodeName: item.JC,
            prop:one,
          };
        }
      })
      if(!this.$route.params.obj.jc){
        this.jcArr = concatList
      }else{
        var jcXzArr = this.$route.params.jcXzArr
        concatList.map(i=>{
          jcXzArr.map(y=>{
            if(y===i.value){
              var one = i.nodeName.slice(0,2)
              var two = i.nodeName.slice(2,4)
              if(i.nodeName === '091011'){
                var three = i.nodeName.slice(4,6)
                this.jcArr.push({
                  arr:[one,two,three],
                  value: one+','+two+','+three,
                  nodeName:i.nodeName,
                  prop:i.prop
                })
              }else{
                this.jcArr.push({
                  arr:[one,two],
                  value: one+','+two,
                  nodeName:i.nodeName,
                  prop:i.prop
                })
              }
            }
          })
        })
      }
      console.log(this.$route.params,this.jcArr)
    },
    async getData(){
      var obj = this.$route.params.obj
      const res = await Api.getIdleClassroom(obj);
      this.jssyzt = res.jssyzt
      res.data.map(i=>{
        var prop = ''
        var zhi = ''
        Object.keys(i.kcsj).map((key,index) => {
          i.kcsj[key].map(y=>{
            zhi = y.zylx
            y.zyjc.map(t=>{
              if(t==='01' || t === '02'){
                prop = '01'
              }
              if(t==='03' || t === '04'){
                prop = '03'
              }
              if(t==='05' || t === '06'){
                prop = '05'
              }
              if(t==='07' || t === '08'){
                prop = '07'
              }
              if(t==='09' || t === '10' || t === '11'){
                prop = '09'
              }
              this.$set(i,prop,zhi)
            })
          })
        })
      })
      this.tableData = res.data
      console.log(this.tableData)
    },
  },
}
</script>
<style lang="less" scoped>
.kxjscxjg{
  padding-bottom: 16px;
  box-sizing: border-box;
  .table{
    padding:10px 16px;
    box-sizing: border-box;
  }
  /deep/.el-table thead.is-group th{
    background: #fff!important;
  }
  /deep/.el-table .cell{
    color:#212f6e
  }
  /deep/.el-table td{
    border-bottom: 1px solid #EBEEF5!important;
  }
  .ys-all{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .ys-li{
      color:#212f6e;
      display:flex;
      font-size: 12px;
      line-height: 15px;
      margin:5px;
    }
  }
  .round{
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-right: 5px;
    border:1px solid #e4e4e4;
    box-sizing: border-box;
  }
  .ys-chen{
    background: #ffe1d3;
    border:1px solid #e1885e;
    box-sizing: border-box;
  }
  .ys-zi{
    background: #e2d3ff;
    border:1px solid #b28de2;
    box-sizing: border-box;
  }
  .ys-lan{
    background: #eff8ff;
    border:1px solid #506dc4;
    box-sizing: border-box;
  }
  .ys-hong{
    background: #ce4e41;
    border:1px solid #ce4e41;
    box-sizing: border-box;
  }
  .ys-lv{
    background: #e4fff9;
    border:1px solid #55baa7;
    box-sizing: border-box;
  }
  .ys-hei{
    background: #000;
    border:1px solid #000;
    box-sizing: border-box;
  }
  .ys-huang{
    background: #fff2d6;
    border:1px solid #c49e48;
    box-sizing: border-box;
  }
  .ys-ban{
    // background: #000;
    // border:1px solid #000;
    // box-sizing: border-box;
    position: relative;
  }
  .ys-ban::before{
    content: '';
    width: 13px;
    height: 7px;
    background: #000;
    position: absolute;
    top:0;
    left: 0;
    border-radius: 10px 10px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/njkxRooms/searTable.vue